export default __webpack_public_path__ + "static/media/music.dc82d83a.jpg";